import { Button, Grid, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { addJudge } from '../AdminMenusRequests'
import toast from 'react-hot-toast'
import { get_rand } from '../../../customprocess/CustomProcess'

export const AddJudge = ({close,setJudges,judges}) => {
    const [userInfo,setUserInfo] = useState({
        username:'',
        code:'',
        name:'',
    })
    useEffect(()=>{
        let num = get_rand(judges);
        setUserInfo({
            ...userInfo,
            code:num
        })
    },[])
    const handleChange = (e,name) => {
        setUserInfo({
            ...userInfo,
            [name]:e.target.value
        })
    }
    const handleSave = async (e) => {
        e.preventDefault();
        const toastId = toast.loading('Adding new judge'); 
        const res = await addJudge(userInfo)
        if(res.data.status === 200){
            setJudges(res.data.data)
            toast.success(res.data.message, {
                id: toastId,
            });
            close();
        }else{
            // toast.dismiss(toastId);
            toast.error(res.data.message, {
                id: toastId,
            });

        }

    }
    return(
        <form onSubmit={handleSave}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField type='text' label ='Username' value={userInfo.username} onChange={(val)=>handleChange(val,'username')} fullWidth required/>
            </Grid>
            <Grid item xs={12}>
                <TextField type='text' label ='Name' value={userInfo.name} onChange={(val)=>handleChange(val,'name')} fullWidth required/>
            </Grid>
            <Grid item xs={12}>
                <TextField type='number' label ='Code' value={userInfo.code} onChange={(val)=>handleChange(val,'code')} fullWidth required InputProps={{readOnly:true}}/>
            </Grid>
            <Grid item xs={12} sx={{display:'flex',gap:1,justifyContent:'flex-end'}}>
                <Button variant='outlined' color='error' onClick={close}>Cancel</Button>
                <Button variant='contained' color='success' type='submit'>Save</Button>
            </Grid>
        </Grid>
        </form>
    )
}